import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import SlugResolver from "@/pages/SlugResolver";
import Realisations from "@/pages/Realisations";
import RealisationDetail from "@/pages/RealisationDetail";
import Conseils from "@/pages/Conseils";
import ConseilDetail from "@/pages/ConseilDetail";
import Zones from "@/pages/Zones";
import Secteurs from "@/pages/Secteurs";
import Contact from "@/pages/Contact";
import About from "@/pages/About";
import { MentionsLegales, Confidentialite } from "@/pages/Legal";
import NotFound from "@/pages/NotFound";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          {/* Admin (standalone, no marketing layout) */}
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<AdminDashboard />} />

          <Route element={<Layout />}>
            <Route path="/" element={<Home />} />
            <Route path="/realisations/" element={<Realisations />} />
            <Route path="/realisations/:slug/" element={<RealisationDetail />} />
            <Route path="/conseils/" element={<Conseils />} />
            <Route path="/conseils/:slug/" element={<ConseilDetail />} />
            <Route path="/zones-intervention/" element={<Zones />} />
            <Route path="/secteurs/" element={<Secteurs />} />
            <Route path="/contact/" element={<Contact />} />
            <Route path="/a-propos/" element={<About />} />
            <Route path="/mentions-legales/" element={<MentionsLegales />} />
            <Route path="/politique-confidentialite/" element={<Confidentialite />} />
            {/* Services + geographic landing pages (root-level slugs) */}
            <Route path="/:slug/" element={<SlugResolver />} />
            <Route path="/404" element={<NotFound />} />
            <Route path="*" element={<NotFound />} />
          </Route>
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </AuthProvider>
  );
}

export default App;
